module.exports = __webpack_public_path__ + "static/img/shuiji7.32e35984.webp";